import React from 'react';
import { View, Text, ActivityIndicator } from 'react-native';
import { globalSyncOverlayStyles } from '../../../../shared/components/feedback/SyncBanner/GlobalSyncOverlay.styles';
import Colors from '../../../../shared/theme/colors';
import { loaderSize } from '../../../../shared/constants/global';
import { GlobalSyncOverlayProps } from '../../../../shared/components/feedback/SyncBanner/GlobalSyncOverlayProps';

/**
 * GlobalSyncOverlay
 *
 * A overlay component to indicate background syncing.
 * - Shows a loader (spinner) and a "Syncing…" message
 * - Blocks interactions (pointerEvents="none" ensures touches pass through)
 * This is usually displayed during background data synchronization.
 */
const GlobalSyncOverlay = ({
  title = 'Syncing…'
}: GlobalSyncOverlayProps) => {
  return (
    <View style={globalSyncOverlayStyles.container} pointerEvents="none">
      <View style={globalSyncOverlayStyles.banner}>
        <ActivityIndicator size={loaderSize.small} color={Colors.black} />
        <Text style={globalSyncOverlayStyles.text}>{title}</Text>
      </View>
    </View>
  );
};

export default GlobalSyncOverlay;
